import { withSvgIconSimple } from './withSvgIconSimple';

export const CancelledIcon = withSvgIconSimple(
  <>
    <circle cx="14" cy="14" r="11" stroke="currentColor" strokeWidth="2.3" />
    <path d="M8 14H20" stroke="currentColor" strokeWidth="2.3" />
  </>,
  { viewBox: '0 0 28 28' },
);
